module.exports={
	"Form": "LocationCreateManifest",
	"Scope": "Location-Create",
	"Descriptors":
	{
		"LocationDetails.Name":
		{
			"Name": "Name",
			"Hash": "Location-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Location-Create-Identity",
				"Group": "Location-Create-Identity"
			}
		},
		"LocationDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Location-Create-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Location-Create-Identity",
				"Group": "Location-Create-Identity"
			}
		},
		"LocationDetails.Type":
		{
			"Name": "Type",
			"Hash": "Location-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details"
			}
		},
		"LocationDetails.Description":
		{
			"Name": "Description",
			"Hash": "Location-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details"
			}
		},
		"LocationDetails.ExternalLocationID":
		{
			"Name": "External Location ID",
			"Hash": "Location-Create-ExternalLocationID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details"
			}
		},
		"LocationDetails.ParentIDLocation":
		{
			"Name": "Parent Location",
			"Hash": "Location-Create-ParentIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Create-Details",
				"Group": "Location-Create-Details",
				"Entity": "Location",
				"SearchFields":
				[
					"Name",
					"Description",
					"QRCode"
				]
			}
		},
		"LocationDetails.IDObservation":
		{
			"Name": "Photo",
			"Hash": "Location-Create-IDObservation",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ObservationPhoto",
				"Row": "5",
				"Width": 12,
				"Section": "Location-Create-Photo",
				"Group": "Location-Create-Photo",
				"PhotoEntity": "Location"
			}
		},
		"LocationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Location-Create-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Location-Create-Contact",
				"Group": "Location-Create-Contact"
			}
		},
		"LocationDetails.Address":
		{
			"Name": "Address",
			"Hash": "Location-Create-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 12,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.City":
		{
			"Name": "City",
			"Hash": "Location-Create-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.State":
		{
			"Name": "State",
			"Hash": "Location-Create-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "Location-Create-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Create-Address",
				"Group": "Location-Create-Address"
			}
		},
		"LocationDetails.Latitude":
		{
			"Name": "Location",
			"Hash": "Location-Create-Latitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "GeolocationSelectorWithMap",
				"Row": "9",
				"Width": 12,
				"Section": "Location-Create-Map",
				"Group": "Location-Create-Map",
				"LatitudeAddress": "LocationDetails.Latitude",
				"LongitudeAddress": "LocationDetails.Longitude"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Location-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Location-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Location-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Location-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Photo",
			"Hash": "Location-Create-Photo",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Photo",
					"Hash": "Location-Create-Photo",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Location-Create-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Location-Create-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "Location-Create-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "Location-Create-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Map Location",
			"Hash": "Location-Create-Map",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Map Location",
					"Hash": "Location-Create-Map",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
